import { getElement, ifSelectorExist } from "./utils";

const localStorageVersion = '1.3'; // Update this version when changes are made


// Update this function to include email replacement in body content
const setEmailFromLocalStorage = (selectedEmail) => {
  if (!selectedEmail) return;

  // Update form recipients
  const formRecipients = document.querySelectorAll('input.form_recipient');
  formRecipients.forEach(inputElement => {
    inputElement.value = decodeURIComponent(selectedEmail);
  });

  // Replace emails in body content
  replaceEmailsInBodyContent(selectedEmail);
};

// Function to set default value for city select
const setDefaultValueForCitySelect = () => {
  const savedCity = localStorage.getItem('selectedCity');
  if (!savedCity) return;

  const selectElement = document.getElementById('city-select');
  for (let i = 0; i < selectElement.options.length; i++) {
    if (selectElement.options[i].text === savedCity) {
      selectElement.selectedIndex = i;
      break;
    }
  }
};

// Function to handle city select event
const citySelectEvent = () => {
  const citySelect = document.getElementById('city-select');
  citySelect.addEventListener('change', function () {
    const selectedOption = this.options[this.selectedIndex];
    const dataAttributes = ['location', 'market', 'gbp', 'phone', 'email', 'address', 'iframe'].reduce((acc, attr) => {
      acc[attr] = selectedOption.getAttribute(`data-${attr}`);
      return acc;
    }, {});

    // Replace phone numbers, set email, keywords, and set local storage items
    replacePhoneNumbers(dataAttributes.phone);
    setEmailFromLocalStorage(dataAttributes.email);
    replaceKeywordsWithCity(dataAttributes.address);
    Object.keys(dataAttributes).forEach(key => localStorage.setItem(`selected${key.charAt(0).toUpperCase() + key.slice(1)}`, dataAttributes[key]));
  });
};


// Function to replace phone numbers
const replacePhoneNumbers = (newPhone) => {
  if (!newPhone) return;

  const simpleNewPhone = newPhone.replace(/[^0-9]/g, "");
  const formattedNewPhone = `(${simpleNewPhone.slice(0, 3)}) ${simpleNewPhone.slice(3, 6)} ${simpleNewPhone.slice(6, 10)}`;
  const formattedOldPhoneRegex = /(\+?1?[-.\s]?(\()?[-.\s]?[0-9]{3}[-.\s]?(\))?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4})/g;

  document.querySelectorAll('a[href^="tel:"]:not(.skip-replace)').forEach(anchor => {
    anchor.childNodes.forEach(node => {
      if (node.nodeType === 3 && node.nodeValue.match(formattedOldPhoneRegex)) {
        node.nodeValue = node.nodeValue.replace(formattedOldPhoneRegex, formattedNewPhone);
      }
    });
    const oldPhoneHref = anchor.getAttribute("href");
    if (oldPhoneHref && oldPhoneHref.match(formattedOldPhoneRegex)) {
      anchor.setAttribute("href", `tel:${formattedNewPhone}`);
    }
  });


  let insertCityName = getElement('.insert-city');
  if (ifSelectorExist(insertCityName)) {
    insertCityName.textContent = localStorage.getItem('selectedLocation');
  }

  // TODO: just in case we want to roll back the sitewide email swaps.
  // let footerEmail = getElement('.site__footer-email');
  // console.log('footerEmail == ', footerEmail)
  // if (ifSelectorExist(footerEmail)) {
  //   footerEmail.textContent = localStorage.getItem('selectedEmail');
  // }
};

// Function to replace keywords with city name
const replaceKeywordsWithCity = (cityName) => {
  if (!cityName) return;

  // Define keywords (commented out for brevity)
  const keywords = ['Select your city'];

  const replaceText = (node) => {
    let modifiedText = node.nodeValue;
    keywords.forEach(keyword => {
      const regExp = new RegExp('\\b' + keyword + '\\b', 'gi');
      modifiedText = modifiedText.replace(regExp, match => match.replace(/Indianapolis|Plainfield|Indiana/gi, cityName));
    });
    node.nodeValue = modifiedText;
  };

  const walk = (node) => {
    if (node.parentNode && node.parentNode.tagName === 'SELECT') return;

    if (node.nodeType === 3) replaceText(node);
    Array.from(node.childNodes).forEach(walk);
  };

  walk(document.body);
};

// Function to clear specific local storage items
const clearLocalStorageItems = (keys) => {
  keys.forEach(key => localStorage.removeItem(key));
};

const checkAndUpdateLocalStorageVersion = () => {
  const storedVersion = localStorage.getItem('localStorageVersion');
  if (storedVersion !== localStorageVersion) {
    clearLocalStorageItems(['selectedPhone', 'selectedEmail', 'selectedCity', 'selectedLocation', 'selectedMarket', 'selectedGbp', 'selectedIframe', 'selectedAddress']);
    localStorage.setItem('localStorageVersion', localStorageVersion);
  }
};

// Check if matchingLocationData is available and set initial values
const setInitialValuesFromMatchingLocationData = () => {
  if (typeof matchingLocationData !== 'undefined') {
    if (!localStorage.getItem('userOverride')) {
      // Use matchingLocationData to set initial values
      replacePhoneNumbers(matchingLocationData.phone);
      setEmailFromLocalStorage(matchingLocationData.email);
      replaceKeywordsWithCity(matchingLocationData.address);
      setDefaultValueForCitySelect(matchingLocationData.gbp_link, matchingLocationData.map_iframe_url, matchingLocationData.location);
      // Store the data in localStorage
      Object.keys(matchingLocationData).forEach(key => {
        localStorage.setItem(`selected${key.charAt(0).toUpperCase() + key.slice(1)}`, matchingLocationData[key]);
      });
    }
  }
};

function insertFooterInfoFromLocalStorage(selectedGbp, selectedIframe, selectedCity) {


  if (selectedGbp && selectedIframe) {
    // Create the HTML content
    if (document.querySelector('body').classList.contains('page-id-13118')) {
      // https://3.basecamp.com/4226914/buckets/35591915/todos/7311283037#__recording_7335059497 - John's task
      return
    }
    let content = `
          <div class="site__footer-gbp">
              <p><a target="_blank" class="gbp-link skip-replace" href="${selectedGbp}">Google Business Profile</a></p>
              <iframe class="gbp-map" src="${selectedIframe}" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              <p style="margin-top: 5px; font-size: 12px;">${selectedCity || ''}</p>
          </div>
      `;

    let contactUsMapUrl = getElement('.contact-info-form-map-block--map_wrapper iframe');
    if (ifSelectorExist(contactUsMapUrl)) {
      contactUsMapUrl.src = selectedIframe;
      console.log('should be inserted to contact us page')
    }

    // Select the element and insert the content
    const footerInfoElement = document.querySelector('.additional-footer-info');
    if (footerInfoElement) {
      footerInfoElement.innerHTML = content;
    }
  }
}

// When body contains location data attribute
function handlePageSelectedLocation() {
  const body = document.querySelector('body');
  const pageSelectedLocation = body.getAttribute('data-page-selected-location');
  const noPhoneSwap = body.classList.contains('no-phone-swap');

  if (pageSelectedLocation && !noPhoneSwap) {
    const selectElement = document.getElementById('city-select');
    const matchingOption = Array.from(selectElement.options).find(option => option.getAttribute('data-location') === pageSelectedLocation);

    if (matchingOption) {
      // Extract and apply data attributes from the matching option
      const dataAttributes = extractDataAttributes(matchingOption);
      applyDataAttributes(dataAttributes);
    }
  }
}
// Function to extract data attributes from an option element
function extractDataAttributes(option) {
  return ['location', 'market', 'gbp', 'phone', 'email', 'address', 'iframe'].reduce((acc, attr) => {
    acc[attr] = option.getAttribute(`data-${attr}`);
    return acc;
  }, {});
}

// Function to apply data attributes (replace phone numbers, set email, etc.)
function applyDataAttributes(dataAttributes) {
  replacePhoneNumbers(dataAttributes.phone);
  setEmailFromLocalStorage(dataAttributes.email);
  replaceKeywordsWithCity(dataAttributes.address);
  insertCityName(dataAttributes.location);
  updateFooterEmail(dataAttributes.email);
}

// Function to update the city name in .insert-city
function insertCityName(cityName) {
  let insertCityName = getElement('.insert-city');
  if (ifSelectorExist(insertCityName)) {
    insertCityName.textContent = cityName;
  }
}

// Function to update the email in .site__footer-email
function updateFooterEmail(email) {
  let footerEmail = getElement('.site__footer-email');
  if (ifSelectorExist(footerEmail)) {
    footerEmail.textContent = email;
  }
}

const replaceEmailsInBodyContent = (newEmail) => {
  if (!newEmail) return;

  // Regular expression to match email addresses
  const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

  // Replace text content email addresses
  const replaceTextEmail = (node) => {
    if (node.nodeType === 3) { // Text node
      const updatedText = node.nodeValue.replace(emailRegex, newEmail);
      if (updatedText !== node.nodeValue) {
        node.nodeValue = updatedText;
      }
    }
  };

  // Update email in <a> tags
  const replaceAnchorEmails = () => {
    document.querySelectorAll('a[href^="mailto:"]').forEach(anchor => {
      const oldEmail = anchor.getAttribute('href').replace('mailto:', '');
      if (oldEmail.match(emailRegex)) {
        anchor.setAttribute('href', `mailto:${newEmail}`);
        if (anchor.textContent.match(emailRegex)) {
          anchor.textContent = anchor.textContent.replace(emailRegex, newEmail);
        }
      }
    });
  };

  // Traverse the document and replace emails
  const traverseAndReplaceEmails = (node) => {
    if (node.nodeType === 3) { // Text node
      replaceTextEmail(node);
    } else if (node.nodeType === 1 && node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') { // Element node
      Array.from(node.childNodes).forEach(traverseAndReplaceEmails);
    }
  };

  // Start traversing the body content
  traverseAndReplaceEmails(document.body);
  // Replace emails in <a> tags
  replaceAnchorEmails();
};



// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  checkAndUpdateLocalStorageVersion(); // Check and update version
  setInitialValuesFromMatchingLocationData();
  setDefaultValueForCitySelect();
  const selectedPhone = localStorage.getItem('selectedPhone');
  const selectedEmail = localStorage.getItem('selectedEmail');
  const selectedCity = localStorage.getItem('selectedLocation');
  const selectedGbp = localStorage.getItem('selectedGbp');
  const selectedIframe = localStorage.getItem('selectedIframe');

  handlePageSelectedLocation();


  const noPhoneSwap = getElement('body').classList.contains('no-phone-swap');
  const pageSelectedLocation = getElement('.body').getAttribute('data-page-selected-location');
  if (!noPhoneSwap && !pageSelectedLocation) {
    insertFooterInfoFromLocalStorage(selectedGbp, selectedIframe, selectedCity);

    if (selectedPhone) replacePhoneNumbers(selectedPhone);
    if (selectedEmail) setEmailFromLocalStorage(selectedEmail);
    citySelectEvent();
    replaceKeywordsWithCity(selectedCity);
  }
});